var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddSheet20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 24.5H24M33 24.5V25.5M33 24.5V20.5V18.5C33 17.3954 32.1046 16.5 31 16.5H28.5H24M15 24.5V30.5C15 31.6046 15.8954 32.5 17 32.5H24M15 24.5V18.5C15 17.3954 15.8954 16.5 17 16.5H24M15 24.5H24M24 16.5V24.5M24 24.5V32.5M24 32.5H26M33 32.5H30M33 32.5V29.5M33 32.5H36M33 32.5V35.5",
    stroke: "#596C85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24.5V30C7.5 31.1046 8.39543 32 9.5 32V32C10.6046 32 11.5 31.1046 11.5 30V24.5M7.5 24.5V19C7.5 17.8954 8.39543 17 9.5 17V17C10.6046 17 11.5 17.8954 11.5 19V24.5M7.5 24.5H11.5",
    stroke: "#596C85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.5V13.5M24 9.5H29H30.5C31.6046 9.5 32.5 10.3954 32.5 11.5V11.5V11.5C32.5 12.6046 31.6046 13.5 30.5 13.5H24M24 9.5H19.5H17.5C16.3954 9.5 15.5 10.3954 15.5 11.5V11.5C15.5 12.6046 16.3954 13.5 17.5 13.5H24",
    stroke: "#596C85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSheet20);
export default __webpack_public_path__ + "static/media/add-sheet-2.0.04ea42ab06c70e2f4dff815d01752bac.svg";
export { ForwardRef as ReactComponent };